/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React, { useState, useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import { useNavigate } from 'react-router';
import {
  PageContainer,
  GoBackLink,
  Heading,
  Logo,
  FormComp,
  SubmitButton,
} from '../components';
import { useSMResetPassword } from '../machines/resetPassword';
import toast from 'react-hot-toast';
import { vappContainer } from '@/application';
import { ResetPasswordPageService } from '../services';
import { StateOSD } from '@vlinder-web/state-osd-v2-widget-react';
import { useSMResetPasswordPageGetContent } from '../machines/pageContent';
import { Loader } from '@/components';

const getSrv = () => {
  return vappContainer.get<ResetPasswordPageService>(
    ResetPasswordPageService.displayName
  );
};

export const ContainerComm = (props: any) => {
  const { resetPasswordMachine, resetPasswordSend, resetPasswordState } =
    useSMResetPassword({});
  const { resetPasswordPageGetContentState } = useSMResetPasswordPageGetContent(
    {}
  );
  const navigate = useNavigate();
  const staticPageContentConfig = getSrv()?.agent?.getStaticPageContentSync({});

  console.log(
    'resetPasswordPageGetContentState =>',
    resetPasswordPageGetContentState
  );

  useEffect(() => {
    if (
      resetPasswordState.matches('RESET_PASSWORD_SUCCESS') &&
      resetPasswordState?.event?.data?.value
    ) {
      toast.success(resetPasswordState?.event?.data?.value?.message);
      navigate('/sign-in');
    }
  }, [
    resetPasswordState.matches('RESET_PASSWORD_SUCCESS') &&
      resetPasswordState?.event?.data?.value,
  ]);

  useEffect(() => {
    if (
      resetPasswordState.matches('RESET_PASSWORD_FAILED') &&
      resetPasswordState?.event?.data?.value
    ) {
      toast.error(resetPasswordState?.event?.data?.value);
    }
  }, [
    resetPasswordState.matches('RESET_PASSWORD_FAILED') &&
      resetPasswordState?.event?.data?.value,
  ]);

  const _onResetPassword = (token: string, data: any) => {
    console.log('_onResetPassword token =>', token);
    console.log('_onResetPassword data =>', data);
    resetPasswordSend('START', {
      payload: {
        password: data.password,
        jwtToken: token,
      },
    });
  };

  const renderSubmitButton = () => {
    return <SubmitButton />;
  };

  // if (resetPasswordState.matches('RESET_PASSWORD_SUCCESS')) {
  //   toast.success(resetPasswordState?.event?.data?.value?.message);
  //   navigate('/sign-in');
  // }

  // if (resetPasswordState.matches('RESET_PASSWORD_FAILED')) {
  //   toast.error(resetPasswordState?.event?.data?.value);
  // }

  const _getPageContent = () => {
    if (
      resetPasswordPageGetContentState?.matches('GET_PAGE_CONTENT') ||
      resetPasswordState?.matches('RESET_PASSWORD')
    ) {
      return (
        <Loader {...(staticPageContentConfig?.loading?.GetPageLoading || {})} />
      );
    }

    if (
      resetPasswordPageGetContentState?.matches('RENDER_PAGE') &&
      resetPasswordState?.nextEvents?.includes('START')
    ) {
      return (
        <>
          <Logo
            logoURL={staticPageContentConfig?.header?.resetPassword?.logo}
          />
          <GoBackLink />
          <Heading
            title={staticPageContentConfig?.header?.resetPassword?.title}
          />
          <Row className="position-absolute mt-8 w-50">
            <Col xs={12} md={12} sm={12}>
              <FormComp
                renderSubmitButton={renderSubmitButton}
                onFormSubmit={_onResetPassword.bind(
                  null,
                  resetPasswordPageGetContentState?.event?.data?.value?.token
                )}
                initialData={
                  resetPasswordPageGetContentState?.event?.data?.value
                    ?.initialData
                }
              />
            </Col>
          </Row>
        </>
      );
    }
  };

  return <PageContainer>{_getPageContent()}</PageContainer>;
};
